var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-block"},[_vm._v(_vm._s(_vm.getDay)+" "+_vm._s(_vm.months[_vm.getMonthName].full)+" "+_vm._s(_vm.getYear)+" at "+_vm._s(_vm.getTime))])}
var staticRenderFns = []

export { render, staticRenderFns }